import axios from 'axios';

const path = "https://moshaf.akademy.ma/"
const audio = ["","waqafaat/","hafs/waqafaat/"]
const pages = ["","waqafaat/","safahaat/hafs/"]
const routes = ["", "/waqafaat" , "/hafs"]
const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJiaXNtaSI6Itio2ZDYs9uh2YXZkCDZsdmE2YTZh9mQINmx2YTYsdmR2Y7Yrduh2YXZjtmA2bDZhtmQINmx2YTYsdmR2Y7YrdmQ2YrZhdmQIiwiYWxhYW4iOiIyNC8wNy8yMDI0IC0g2KfZhNij2LHYqNi52KfYoSAxOCDZhdit2LHZhSAxNDQ2IiwiaWF0IjoxNzI2ODQyNjIzfQ.svD2I5wZTnz0J65-TWcAbY5JGfH76_jFPVbyaTAE7n4"

const Api = axios.create({

  baseURL: `https://api.akademy.ma`,   

  headers : {
    'Authorization': `Bearer ${token}`,       
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

 const onGet = (request, Items, Load, Message) => {
  //alert('Moshaf.Load '+request)
  Items([])
  Api.get(request)
  .then(response => {
      //console.log('Moshaf.Get', request, response.data); alert('Moshaf.Load '+request)
      Items(response?.data)
      Load && Load(true)
  })
  .catch(error => {
      //console.log('Error',request,error) //; alert(request)
      Message && Message(error)
  })
}

const onPut = (version, id, field, value, Message) => {

  if(id && id>0 && field && value) {
    //let query=`/waqafaat/${id}/${field}/${value}`
    let query = routes[version] + `/${id}/${field}/${value}`
    //alert(query); //return;

    Api.put(query)
    .then(response => {
      let rows=response.data.affectedRows
      Message && Message(`${rows} updated`)
      //console.log('Moshaf.onUpdate', response.status, response.data.affectedRows)
    })
    .catch(error => {
      Message && Message(error)
      console.error(error)
    })
  }
}


const getPage = (page, version=1, type='jpg') => {
  let file=''
  if(page>0) {
    let name = (page||0).toString().padStart(3,'0')+'.'+type
    if(version===2)
      name = (page||0).toString().padStart(3,'0')+'.'+type
    
    return path+pages[version]+name
  }
  else 
    return file
}

const getPart = (item, version=1, type='mp3') => {
  if(item){
    let name="";
    if(version===1)
      name = `${item.Soora.toString().padStart(3,'0')}/${item.Sah}.${type}`
    else if(version===2)
      name = `${item.Soora.toString().padStart(3,'0')}/${item.Sah}.${type}`

    return path+audio[version]+name
  }
}

const getFile = (soora, safha, version=1, type='mp3') => {
  let name = `${soora.toString().padStart(3,'0')}/${safha.toString().padStart(3,'0')}.${type}`
  //setCache(name)
  return path+audio[version]+name
}

const setCache = (url) => {
  if ('caches' in window) {
    caches.open('CacheAkademy').then(cache => {
      //alert(url)
      cache.add(url)
      console.log(cache)
    });
  }
}

function isArNum(word) {
    return /^[\u0660-\u0669]+$/.test(word);
}

// تحويل الأرقام إلى العربية
const transNum = (text) => {
    return text.replace(/[\u0660-\u0669]/g, function (digit) {
        return String.fromCharCode(digit.charCodeAt(0) - 0x0660 + 48);
    });
}

function isNum(word) {
    return /^\d+$/.test(word);
}

const transMin = (min, rect, pane) => {
  if(min.includes('px'))
      return min
  if(min.includes(',')) {
      
      if(rect?.right>0 && rect?.bottom>0) {

          let w=parseInt(rect.right-rect.left)
          let h=parseInt(rect.bottom-rect.top)

          let xy = min.split(',')
          let top = parseInt(xy[0]*h/100)+'px'
          let right = parseInt(xy[1]*w/100 + (pane.right-rect.right))+'px'
          return {top, right}
      }
  }
}

const transMins = (items, rect, pane) => {
  return new Promise(function (resolve, reject) { 
    if(items?.length>0) {
        let step = Math.round(100/(items.length/2+1))

        for(let p=0; p<items.length; p++) { 
            items[p].Locked = 0

            let min = items[p].Min ?? ''
            if (typeof min === 'string') {
              //alert(`min=${min} items=${JSON.stringify(items)}`)
              if(['','0,0'].includes(min)) {
                  let t = 2 + Math.trunc(p/2) * step
                  let r = 2 + 43 * (p%2)

                  min = `${t},${r}`
              }              
              items[p]['Pos'] = transMin(min,rect,pane)

              //console.log(items[p].Min) // MeR 0920 Bug when starting 
            }
            else {
              // is transed !
            }

            if(p+1===items.length) {
                resolve(items)
            }
        }
    }
  })}

export {Api, onGet, onPut, getPage, getPart, getFile, transMin, transMins, transNum, isNum, isArNum, setCache}
